import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { Modal } from "../../../../components";

class DeleteJobConfirmationModal extends Component {
	constructor(props) {
		super(props);

		this.initialState = {};
		this.state = { ...this.initialState };
	}

	onHide = () => {
		const { onCancel } = this.props;
		onCancel();
		this.setState({ ...this.initialState });
	};

	render() {
		const { lang } = global;
		const { show, jobEventId, lineItems, onCancel, onConfirm } = this.props;

		const jobEventLineItems = lineItems.filter(i => i.JobEventId === jobEventId);

		return (
			<Modal
				id="manual-invoice-dj-modal"
				show={show}
				onHide={this.onHide}
			>
				<Modal.Header closeButton>{lang.t("Confirm Job Removal")}</Modal.Header>
				<Modal.Body>
					{jobEventLineItems.length > 1
						? lang.t("By removing this job, the following line items will be deleted_")
						: lang.t("By removing this job, the following line item will be deleted_")}
					<br />
					<br />
					<div className="row hidden-xs">
						<div className="col-sm-4">
							<strong>{lang.t("Officer")}</strong>
						</div>
						<div className="col-sm-2 text-sm-right">
							<strong>{lang.t("Rate")}</strong>
						</div>
						<div className="col-sm-2 text-sm-right">
							<strong>{lang.t("Hours")}</strong>
						</div>
						<div className="col-sm-2 text-sm-right">
							<strong>{lang.t("Fees")}</strong>
						</div>
						<div className="col-sm-2 text-sm-right">
							<strong>{lang.t("Total")}</strong>
						</div>
					</div>
					<For
						each="item"
						of={jobEventLineItems}
					>
						<div
							className="row del-item"
							key={`del-item-${item.OfficerId || "e"}_${item.OfficerName.replace(/\s/g, "")}`}
						>
							<div className="col-sm-4">
								{item.OfficerName}
								{item.PONumber ? ` - ${item.PONumber}` : ""}
							</div>
							<div className="col-sm-2 text-sm-right">
								{utils.currencyFormatter(item.Rate)}
								<span className="visible-xs-inline">{lang.t("_hour")}</span>
							</div>
							<div className="col-sm-2 text-sm-right">
								{item.Hours}
								<span className="text-lowercase">&nbsp;{lang.t("Hours")}</span>
							</div>
							<div className="col-sm-2 text-sm-right">
								<span className="visible-xs-inline">{lang.t("Fees")}:&nbsp;</span>
								{utils.currencyFormatter(item.Total - item.OfficerPay)}
							</div>
							<div className="col-sm-2 text-sm-right">
								<strong className="visible-xs-inline">
									{lang.t("Total")}:&nbsp;
								</strong>
								<strong>{utils.currencyFormatter(item.Total)}</strong>
							</div>
						</div>
					</For>
					<br />
					{lang.t("Are you sure you want to remove this job_")}
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={() => onCancel()}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => onConfirm()}
					>
						{lang.t("Confirm")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

DeleteJobConfirmationModal.propTypes = {
	show: PropTypes.bool,
	jobEventId: PropTypes.number,
	lineItems: PropTypes.array,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
};

DeleteJobConfirmationModal.defaultProps = {
	show: false,
	jobEventId: undefined,
	lineItems: [],
	onCancel: () => {},
	onConfirm: () => {},
};

export default DeleteJobConfirmationModal;
